import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RechargeSansInscriptionService } from './../../api/recharge-sans-inscription.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-retour-recharge-sans-inscription',
  templateUrl: './retour-recharge-sans-inscription.component.html',
  styleUrls: ['./retour-recharge-sans-inscription.component.scss']
})
export class RetourRechargeSansInscriptionComponent implements OnInit {


  guid: string;
  stationDetail: any;
  subscription: Subscription;

  hide = true;
  formGroup: FormGroup;
  submitted = false;
  loading = false;



  constructor(private rechargeSansInscriptionService: RechargeSansInscriptionService, private router: Router, private snackBar: MatSnackBar, private formBuilder: FormBuilder, private sanitizer: DomSanitizer) 
  { this.getInfoRecharge() }


  ngOnInit(): void {
    this.createForm();
  }




  getInfoRecharge() {
    this.subscription = this.rechargeSansInscriptionService.currentrecharge_info.subscribe(res => {
      console.log(res);
      if (res) {
        this.stationDetail = res.station
      }
    })
  }







  // reactive form
  createForm() {

    let pinregex: RegExp = /^[0-9]+$/;

    this.formGroup = this.formBuilder.group({
      pin: [null, [Validators.required, Validators.minLength(4), Validators.maxLength(9), Validators.pattern(pinregex)]],
    }
    );
  }





  getErrorPin() {
    return this.formGroup.get('pin').hasError('required') ? 'Le code PIN requis' :
      this.formGroup.get('pin').hasError('pattern') ?
        'Le code PIN est invalide' : 'Le code PIN doit comporter 4 chiffres';
  }




  sanitizeImageUrl(imageUrl: any): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
}






 //send user  with POST
 postPinBook() {

 
  if (this.formGroup.invalid) {
    return;
  }

  let Data = this.formGroup.value;

  console.log("formulaire")

  console.log(Data)

  Data.station_id = this.stationDetail.id;
  Data.id_pl = this.stationDetail.id_pl;
  Data.guid = this.stationDetail.guid;

  this.rechargeSansInscriptionService.postPinBookRecharge(Data).subscribe(
    data => {
      this.loading = false;
      console.log(data)
      //this.openSnackBarDone('Compte créé avec succès')
      this.rechargeSansInscriptionService.changeRechargeInfo({station: this.stationDetail, token: data.data.token});
      this.router.navigate([`/retour/confirm`]);

    },
    err => {
      this.loading = false;
      console.log(err)
      this.openSnackBar(err.error.message)
    });

}



openSnackBar(message: string) {
  this.snackBar.open(message, "X", {
    panelClass: ['error-snackbar'],
    duration: 20000,
  });
}




}
